import { AllupBetlineFragment } from '@graphqlTypes/sitecore';
import { kolNonPageTracker } from '@src/adobe-launch/data-layer-provider';
import { TrackingEvent } from '@src/adobe-launch/types';
import { allUpItemFragment } from '@src/utils/type-utils';
import { useTranslation } from 'next-i18next';
import React from 'react';

type Props = {
    raceNo: string;
    curAllUpItem: allUpItemFragment | null;
    isAllUpStrike?: boolean;
    AllUpDataItem?: AllupBetlineFragment | null;
};

const STRIKE_STYLE =
    'text-white font-bold text-[16px] absolute left-[-1px] top-[-1px] rounded-br-lg bg-[#FF9900] py-1.5 pl-3 pr-2';

const AllUpItemButton = ({ raceNo, AllUpDataItem }: Props) => {
    const { t, i18n } = useTranslation('kol');

    const enlang = i18n.language.toLowerCase() === 'en-us';
    const status = AllUpDataItem?.allUpButtonStatus?.value;
    const kolData = AllUpDataItem?.kolProfile?.targetItem;
    const KolName = kolData?.name ?? '';
    const enAllUp = enlang ? 'All Up' : '過關';

    // console.log('AllUpDataItem----', AllUpDataItem);

    if (status === 'BetLink') {
        const handleClick = () => {
            kolNonPageTracker({
                eventID: TrackingEvent.BetPickCTA,
                betLink: enAllUp,
                betType: enAllUp,
                raceID: raceNo,
                kolName: KolName,
            });
        };
        return (
            <a
                href={AllUpDataItem?.allUpBetlineUrl?.value}
                target='_blank'
                className='h-[30px] mt-[12px] bg-[#FFD505] text-[16px] rounded-full flex items-center justify-center font-medium'
                onClick={handleClick}
            >
                {t('betpick.betNow')}
            </a>
        );
    }

    if (status === 'Strike') {
        return <div className={STRIKE_STYLE}>{t('betpick.allUpStrike')} 🎉🎉</div>;
    }

    if (status === 'VOID') {
        return <div className='text-center font-bold py-1'>{t('betpick.void')}</div>;
    }

    return null;
};

export default AllUpItemButton;
